// biome-ignore lint/suspicious/noExplicitAny: JWT payloads can contain arbitrary fields
export const decodeJWT = (token: string): { [key: string]: any } => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`) // `
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error(e);
    const errorMessage = e instanceof Error ? e.message : 'Unknown error';
    throw Error(`Failed to decode the token: ${errorMessage}`);
  }
};
